

































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { FormChangeEvent, FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import Confirmation from '@/components/Confirmation.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import ConfirmacionEliminar from '@/reusable/Mantenedor/ConfirmacionEliminar.vue';
import moment from 'moment';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { number } from 'node_modules/@types/yup';

@Component({
  components: {
    FormFieldsContainer,
    Confirmation,
    ConfirmacionEliminar,
    MantenedorGrid,
  },
})
export default class ComandoVelocidadAsignacion extends Vue {
  @Prop({ default: false }) isVerDetalle: boolean;
  @Prop({ default: false }) esEditar: boolean;

  mostrarConfirmacionEliminar: boolean = false;
  mostrarDatos: boolean = false;
  mostrarModalCrear: boolean = false;
  mostrarModalEditar: boolean = false;

  hint: string = '';
  estado: boolean = true;
  seleccionEstado: number = 0;
  titulo: string = 'Seleccionar Velocidad Máxima';
  asignacionVelocidad: number;

  isValidateTP: boolean = false;
  isValidateRM: boolean = false;

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  formFields: FormFieldDefMap = {
    vmaxima: {
      label: 'Velocidad Máxima',
      id: 'vmaxima',
      value: '',
    },
  };

  created() {
    this.isValidateTP = false;
    this.isValidateRM = false;
    if (this.isVerDetalle) {
      this.titulo = 'Velocidad Máxima';
    }
  }

  handleCierraModalSinGuardar() {
    this.mostrarModalCrear = false;
    this.mostrarModalEditar = false;
  }

  async handleCierreModalBtnGuardar(e: FormChangeEvent) {
    this.mostrarModalCrear = false;
  }
  async handleCierreModalBtnGuardarEditar(e: FormChangeEvent) {}

  constructor() {
    super();
  }

  @Watch('formFields', { deep: true })
  handleFormChange(fields: FormFieldDefMap) {
    this.asignacionVelocidad = parseInt(
      this.formFields.vmaxima.value.toString()
    );
    this.$emit('handleFormChangeEventosVelocidad', this.asignacionVelocidad); // tiene el nombre del objeto a quien le devuelve el valor
  }
}
